import { ReactNode } from "react";
import { LayoutProvider } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";

export default function MetronicLayout({ children }: { children: ReactNode }) {
    return (
        <LayoutProvider>
            {children}
            <MasterInit />
        </LayoutProvider>
    );
}